module.exports = __webpack_public_path__ + "img/no_content.ebf9325f.png";